import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-edit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.scss"],
})
export class EditComponent implements OnInit {
  form: FormGroup;
  image_edit = false;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  permissions = [];
  show = false;
  constructor(
    private formbuilder: FormBuilder,
    private service: GlobalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.form = this.formbuilder.group({
      category_id: [this.data.id, Validators.required],
      name_ar: [this.data.name_ar, Validators.required],
      name_en: [this.data.name_en, Validators.required],
      // description_en:[this.data.description_en,Validators.required],
    });
    // this.permissions = [...this.data.roles]

    this.selectedItems = [];
    for (let i = 0; i < this.dropdownList.length; i++) {
      for (let y = 0; y < this.data?.sections.length; y++) {
        if (this.dropdownList[i]?.section_name == this.data?.sections[y]) {
          this.selectedItems.push(this.dropdownList[i]);
        }
      }
      console.log(
        this.dropdownList[1].section_name,
        this.data?.sections[i],
        "just for test"
      );

      // console.log("this is i" , this.dropdownList[i]);
    }
    this.permissions = this.selectedItems;
    this.dropdownSettings = {
      singleSelection: false,
      idField: "section_id",
      textField: "section_name",
      selectAllText: " اختيار الكل",
      unSelectAllText: " الغاء الاختيار",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    console.log("this.data");
    console.log(this.data);
  }

  files: File[] = [];

  onSelect(event) {
    console.log(event.addedFiles[0]);
    this.files = [];
    this.files.push(...event.addedFiles);
  }
  onItemSelect(item: any) {
    console.log(this.permissions);

    this.permissions.push(item);

    console.log(item);
  }


  itemDeselect(item: any){
    this.permissions.splice(this.permissions.indexOf(item), 1);
      console.log("removed");
      return;
  }

  onSelectAll(items: any) {
    console.log(items);
    this.permissions = items;
    if (this.permissions.length > 0) {
      this.permissions = [];
    }
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  submit() {
    console.log("Form Work");
    this.spinner.show();
    let form = {

      category_id: this.data.id,
      ...this.form.value,
      image: this.files[0],
    };
    console.log("submitting the form", form);
    this.service.editCategory(form).subscribe((res: any) => {
      console.log(res);
      this.spinner.hide();
      if (res.status == true) {
        Swal.fire("نجاح", "تم تعديل الادمن بنجاح", "success");
      } else {
        // for (let i = 0; i < res.errors.length; i++) {
        //   this.toastr.error(res.errors[i]);
        // }
      }
      this.dialog.closeAll();
    });
  }
}
